export const GET_LEVEL_LIST = 'level/getLevelList';
export const GET_LEVEL_LIST_SUCCESS = 'level/getLevelListSuccess';
